import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditArrows = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.14859 2.83L8.31859 6L9.72859 4.59L5.14859 0L0.558594 4.59L1.97859 6L5.14859 2.83ZM5.14859 15.17L1.97859 12L0.568594 13.41L5.14859 18L9.73859 13.41L8.31859 12L5.14859 15.17Z",
		fill: "#616161"
	})]
});
const ForwardRef = forwardRef(SvgEditArrows);
export { ForwardRef as ReactComponent };
